import { forwardRef } from "react";

const withSkeleton = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        isLoading,
        skeletonHeight = 40,
        skeletonWidth = "100%",
        ...props
      }: {
        isLoading: boolean;
        skeletonHeight: number | string;
        skeletonWidth: number | string;
        [key: string]: any;
      },
      ref,
    ) => {
      return (
        <Component
          ref={ref}
          isLoading={isLoading}
          skeletonHeight={skeletonHeight}
          skeletonWidth={skeletonWidth}
          {...props}
        />
      );
    },
  );
};

export default withSkeleton;
